import { Component,ViewChild } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { AdministratorService } from '../../../../services/administrator.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import _ from 'lodash';
import { gridPageRequest, gridPagination } from '../../../../model/common/common.model';
import { UnitsOfMeasure, UnitsOfMeasureGridResponse } from '../../../../model/administration.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';



@Component({
  selector: 'app-list-unit-of-measure',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './list-unit-of-measure.component.html',
  styleUrl: './list-unit-of-measure.component.scss'
})
export class ListUnitOfMeasureComponent {
  selectedUnitsOfMeasurement: UnitsOfMeasure[] = [];
  loader: boolean = false;
  searchKey : any;
  paginator: boolean | undefined;


  constructor(private UnitsOfMeasureService: AdministratorService, private route: Router, private messageService: MessageService, private confirmationService:ConfirmationService) { }
  @ViewChild('dt1') dt1: Table | undefined;
  UnitsOfMeasures: UnitsOfMeasure[] = [];
  start: number = 0;
  rowsPerPage: number = 10; //code added here
  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 0
  }


  result: UnitsOfMeasureGridResponse = {
    unitsofMeasures: [],
    totalRecords: 0
  }

pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 50,
    id: 0
  }

  ngOnInit(): void {
    // this.pageRequest.pageIndex = 0;
    // this.pageRequest.pageSize = this.rowsPerPage
    document.title = 'Unit of Measure List';
    this.getUnitsOfMeasure(this.pageRequest);
    this.searchEffect();
   }

  getUnitsOfMeasure(query: gridPageRequest) {
    this.UnitsOfMeasureService.getAllUnitsOfMeasure(query).subscribe({
      next: data => {
        this.result = data as UnitsOfMeasureGridResponse;
        this.pageCalculation();
      },
      error: error => {
        console.log(error);
      }
    });
  }

  pageCalculation() {
    // this.pageRequest.pageSize = this.rowsPerPage;
    let last = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + this.pageRequest.pageSize;
    this.gridPagination.first = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + 1;
    this.gridPagination.last = last < this.result.totalRecords ? last : this.result.totalRecords;
    this.gridPagination.totalRecords = this.result.totalRecords;
    // this.paginationLabel = _.toString(this.pageRequest.pageIndex * this.pageRequest.pageSize) + (this.result.)
  }

  createUnitsOfMeasure() {
    this.route.navigate(['/home/createUnitsOfMeasure']);
  }

  editUnitsOfMeasure(data?:any) {
    if(data){
      this.route.navigate(['/home/createUnitsOfMeasure'], { queryParams: { 'unitOfMeasureId': data }, skipLocationChange: true },);
    }else{
      this.route.navigate(['/home/createUnitsOfMeasure'], { queryParams: { 'unitOfMeasureId': this.selectedUnitsOfMeasurement[0].unitsofMeasureId }, skipLocationChange: true },);
    }
  }


  // deleteUnitsOfMeasure() {
  //   if (this.selectedUnitsOfMeasurement && this.selectedUnitsOfMeasurement.length > 0) {
  //     var UnitsOfMeasurementIds = _.map(this.selectedUnitsOfMeasurement, 'unitsofMeasureId');
  //     this.UnitsOfMeasureService.deleteUnitsOfMeasure(UnitsOfMeasurementIds).subscribe({
  //       next: data => {
  //         this.selectedUnitsOfMeasurement = [];
  //         this.getUnitsOfMeasure(this.pageRequest);
  //       },
  //       error: error => {

  //       }
  //     });
  //   }
  // }

  deleteUnitsOfMeasure() {
    this.confirmationService.confirm({
        header: 'Are you sure?',
        message: 'Please confirm to proceed.',
        accept: () => {
            this.loader = true;
            if (this.selectedUnitsOfMeasurement && this.selectedUnitsOfMeasurement.length > 0) {
                var UnitsOfMeasurementIds = _.map(this.selectedUnitsOfMeasurement, 'unitsofMeasureId');
                this.UnitsOfMeasureService.deleteUnitsOfMeasure(UnitsOfMeasurementIds).subscribe({
                    next: data => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Units of Measurement deleted successfully.' });
                        this.loader = false;
                        this.selectedUnitsOfMeasurement = [];
                        this.getUnitsOfMeasure(this.pageRequest);
                    },
                    error: error => {
                        this.loader = false;
                        console.log(error);
                    }
                });
            }
        },
        reject: () => {
        }
    });
}

  //onPrevious() {
   // this.pageRequest.pageIndex = this.pageRequest.pageIndex - 1;
   // this.getUnitsOfMeasure(this.pageRequest);
  //}

  //onNext() {
   // this.pageRequest.pageIndex = this.pageRequest.pageIndex + 1;
   // this.getUnitsOfMeasure(this.pageRequest);
 // }

  //code added here
  unitsOfMeasures(event:any){
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.searchUOM();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getUnitsOfMeasure(this.pageRequest);
    }
  }
 searchUOM() {
    if (!this.searchKey) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter a search keyword' });
      return;
    }

    // this.loader = true;

    this.UnitsOfMeasureService.autoSearchUMO(this.searchKey).subscribe(
      (data: any) => {

        if (Array.isArray(data)) {
          this.result.unitsofMeasures = data;

          this.pageRequest.pageSize = this.result.unitsofMeasures.length;
          this.gridPagination = {
            ...this.gridPagination,
            totalRecords: this.result.unitsofMeasures.length,
          };
          this.paginator = false;
        }
        else if (data && Array.isArray(data.unitsofMeasures)) {
          this.result.unitsofMeasures = data.unitsofMeasures;

          this.pageRequest.pageSize = this.result.unitsofMeasures.length;
          this.gridPagination = {
            ...this.gridPagination,
            totalRecords: this.result.unitsofMeasures.length,
          };
          this.paginator = false;
        }
        else {
          this.result.unitsofMeasures = [];
        }

        // this.loader = false;
      },
      (error: any) => {
        console.error('Search error:', error);
        // this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data' });
      }
    );
  }
 
  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0; 
      this.dt1.clear();
    }
    this.searchKey = ''; 
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50; 
    this.getUnitsOfMeasure(this.pageRequest); 
  }

  
  placeholder: string = 'Search By ';
  private messages: string[] = ['UOM Code', 'Units Of Measure', 'UOM Description'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }
}
